import { InventoryItemOutcome } from "@redotech/crdb-enums/inventory/inventory-item-outcome";
import { returnsCenterIdFormat } from "@redotech/redo-warehouse-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getReturnsCenterSupportedOutcomes = unaryRpc({
  name: "getReturnsCenterSupportedOutcomes" as const,
  input: z.object({ returnsCenterId: returnsCenterIdFormat.schema }),
  output: z.object({
    /** Includes the outcomes every center supports. */
    supportedOutcomes: z.array(z.enum(InventoryItemOutcome)),
  }),
});
